module.exports = __webpack_public_path__ + "static/media/Vigen_Coromoto_Altar_Mayor.64e88132.jpg";